export abstract class Event {
  static readonly type: string = ''

  public readonly type: string = ''
}
